mutation DeleteAsset($assetId: ID!) {
  result: StreamToolsDeleteAsset(assetId: $assetId) {
    id
    deleted
  }
}
